module.exports = __webpack_public_path__ + "img/digitize.6a764fda.png";